import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../../DomainTypes';
import Group from '../../Models/Catalogue/Reporting/Group';
import BranchDetailLookup from '../../Models/Catalogue/Reporting/Lookups/BranchDetailLookup';
import TableLookup from '../../Models/Catalogue/Reporting/Lookups/TableLookup';

export interface IReportingApiClient {

    getGroups(): AxiosPromise<Array<Model.PlainTrackedObject<Group>>>;

    saveGroups(groups: Array<Model.PartialPlainObject<Group>>): AxiosPromise<Array<Model.PlainTrackedObject<Group>>>;

    /** 
     * Gets a list of the branch detail lookups.
     */
    getBranchDetailLookups(): AxiosPromise<Array<Model.PlainObject<BranchDetailLookup>>>;

    /** 
     * Gets a list of the business detail lookups.
     */
    getBusinessUnitDetailLookups(): AxiosPromise<Array<Model.PlainObject<BranchDetailLookup>>>;

        /** 
     * Gets a list of table lookups
     */
    getTableLookups(): AxiosPromise<Array<Model.PlainObject<TableLookup>>>;

    // Client only properties / methods
}

@injectable()
export default class ReportingApiClient extends Data.ApiClientBase implements IReportingApiClient {

    constructor(config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/catalogue/reporting`);
    }

    public getGroups(): AxiosPromise<Array<Model.PlainTrackedObject<Group>>> {
        return this.axios.get(`${this.apiPath}/groups`);
    }

    public saveGroups(groups: Array<Model.PartialPlainObject<Group>>): AxiosPromise<Array<Model.PlainTrackedObject<Group>>> {
        return this.axios.post(`${this.apiPath}/groups`, groups);
    }

    public getBranchDetailLookups(): AxiosPromise<Array<Model.PlainObject<BranchDetailLookup>>> {
        return this.axios.get(`${this.apiPath}/branch-detail`);
    }

    public getBusinessUnitDetailLookups(): AxiosPromise<Array<Model.PlainObject<BranchDetailLookup>>> {
        return this.axios.get(`${this.apiPath}/business-unit-detail`);
    }

        public getTableLookups(): AxiosPromise<Array<Model.PlainObject<TableLookup>>> {
        return this.axios.get(`${this.apiPath}/table-lookups`);
    }

    // Client only properties / methods
}